import { useNavigate } from 'react-router-dom';
import { IoCallOutline, IoTimeOutline } from 'react-icons/io5';
import type { PickupPoint } from '../../types';
import { formatPhoneNumber } from '@shared/utils';
import './PickupPointCard.css';

interface PickupPointCardProps {
  pickupPoint: PickupPoint;
}

export default function PickupPointCard({ pickupPoint }: PickupPointCardProps) {
  const navigate = useNavigate();
  const raw = pickupPoint.metroIconColor?.trim();
  const metroColor = !raw ? '#E65A8C' : raw.startsWith('#') ? raw : `#${raw}`;
  const inactive = pickupPoint.isOperationallyInactive === true;

  return (
    <button
      type="button"
      className="pickup-point-card"
      onClick={() => navigate(`/contacts/pickup-points/${pickupPoint.id}`)}
    >
      <span
        className={
          inactive
            ? 'pickup-point-card__status pickup-point-card__status--off'
            : 'pickup-point-card__status pickup-point-card__status--on'
        }
      >
        {inactive ? 'Не работает' : 'Активна'}
      </span>

      <div className="pickup-point-card__header">
        {pickupPoint.city ? (
          <div className="pickup-point-card__city">{pickupPoint.city}</div>
        ) : null}
        <h3 className="pickup-point-card__title">{pickupPoint.address}</h3>
        {pickupPoint.metro ? (
          <div className="pickup-point-card__metro">
            <svg
              className="pickup-point-card__metro-icon"
              width="14"
              height="10"
              viewBox="0 0 14 10"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden
              style={{ ['--metro-fill' as string]: metroColor }}
            >
              <path d="M9.75441 0L13.0328 8.60245L14 8.6052V9.89831H9.04351V8.6052H9.77423L9.06333 6.46832L6.99009 10L4.91685 6.46832L4.20595 8.6052H4.93667V9.89831H0V8.6052H0.947429L4.22577 0L6.99009 5.02954L9.75441 0Z" />
            </svg>
            <span>{pickupPoint.metro}</span>
          </div>
        ) : null}
      </div>

      <div className="pickup-point-card__meta">
        {pickupPoint.phoneNumber ? (
          <div className="pickup-point-card__row">
            <IoCallOutline size={15} aria-hidden />
            <span>{formatPhoneNumber(pickupPoint.phoneNumber)}</span>
          </div>
        ) : null}

        {pickupPoint.workingHoursFormatted && pickupPoint.workingHoursFormatted.length > 0 ? (
          <div className="pickup-point-card__hours">
            <IoTimeOutline size={15} className="pickup-point-card__hours-icon" aria-hidden />
            <div className="pickup-point-card__hours-list">
              {pickupPoint.workingHoursFormatted.map((timeStr, index) => (
                <div key={index}>{timeStr}</div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </button>
  );
}
